/**
 * Utilitário para Microsoft Clarity
 * Fornece funções para inicializar e gerenciar o Microsoft Clarity
 */

// Estendendo a interface Window para incluir a propriedade clarity
declare global {
  interface Window {
    clarity?: any;
  }
}

/**
 * Inicializa o Microsoft Clarity
 * @param clarityId - ID do projeto Clarity
 */
export const initializeClarity = (clarityId: string = 'ry3sqhw3tq'): void => {
  if (typeof window !== 'undefined' && !window.clarity) {
    (function (c: Window, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Element) {
      (c as any)[a] = (c as any)[a] || function () { ((c as any)[a].q = (c as any)[a].q || []).push(arguments); };
      t = l.createElement(r) as HTMLScriptElement;
      if (t) {
        t.async = true;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        if (y && y.parentNode) {
          y.parentNode.insertBefore(t, y);
        }
      }
    })(window, document, "clarity", "script", clarityId);
  } else if (window.clarity) {
    console.log('Clarity está inicializado');
  }
};

/**
 * Remove o script do Clarity do DOM
 */
export const removeClarity = (): void => {
  if (typeof window !== 'undefined') {
    // Remove o script do Clarity
    const clarityScripts = document.querySelectorAll('script[src*="clarity.ms"]');
    clarityScripts.forEach(script => script.remove());

    // Remove a propriedade clarity do objeto window
    if (window.hasOwnProperty('clarity')) {
      delete (window as any).clarity;
    }

    console.log('Microsoft Clarity removido com sucesso');
  }
};
